export type GamePlatform =
  | { kind: "standalone" }
  | { kind: "vkplay" | "vkgames"; appId: string; launchParams: string };

export type PlatformLaunch =
  | { kind: "standalone" }
  | { kind: "vkplay" | "vkgames"; launchParams: string };

export const STANDALONE: GamePlatform = { kind: "standalone" };

export function capturePlatformLaunch(
  location: Pick<Location, "pathname" | "search">,
  history: Pick<History, "replaceState">,
): PlatformLaunch {
  const vkPlay = location.pathname === "/vkplay" || location.pathname === "/vkplay/";
  const vkGames =
    location.pathname === "/vk" ||
    location.pathname === "/vk/" ||
    (location.pathname === "/" &&
      [...new URLSearchParams(location.search).keys()].some((key) =>
        key.startsWith("vk_"),
      ));
  if (!vkPlay && !vkGames) return { kind: "standalone" };
  const launchParams = location.search.replace(/^\?/, "");
  history.replaceState(null, "", vkPlay ? "/vkplay" : "/vk");
  return { kind: vkPlay ? "vkplay" : "vkgames", launchParams };
}
